// extracted by mini-css-extract-plugin
module.exports =  {"nameCellContent":"style-module_nameCellContent__oBNsyrpcSPEeVg8iO1E3","spacer":"style-module_spacer__pIgiFsrH3y9KbfY36aTA","value":"style-module_value__Gwo8w278Jf38t26QLZDu"};